import React, { useState } from 'react';
import Rating from 'react-rating';
import classes from './Rating.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RatingComponent = ({
  initialRating,
  onChange,
  numberOfRatings,
  readonly = false
}) => {
  const [ratingOnHover, setRatingOnHover] = useState(0);
  const [submittedRating, setSubmittedRating] = useState(initialRating);

  const onRatingChange = value => {
    setSubmittedRating(value);
    onChange(value);
  };

  return (
    <div className={classes['rating-container']}>
      <span className={classes['rating-value-as-text']}>
        {ratingOnHover || `${submittedRating ? submittedRating : ''}`}
      </span>

      <span className={classes['star-rating-container']}>
        <Rating
          emptySymbol={
            <FontAwesomeIcon icon={['far', 'star']} color="orange" />
          }
          fullSymbol={<FontAwesomeIcon icon={['fas', 'star']} color="orange" />}
          initialRating={submittedRating}
          onChange={onRatingChange}
          fractions={2}
          readonly={readonly}
          onHover={rate => setRatingOnHover(rate)}
        />
      </span>

      {numberOfRatings ? (
        <span className={classes['ratings-number']}>
          ({numberOfRatings} Reviews)
        </span>
      ) : null}
    </div>
  );
};

export default RatingComponent;
